import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { MaterialModule } from './shared/material.module';
import { trackerModalComponent } from './component/modals/tracker-modal/tracker-modal.component';

import { NgxPermissionsModule } from 'ngx-permissions';
import { LoginComponent } from './component/login/login.component';
import { MenuComponent } from './component/menu/menu.component';
import { AuthService } from './services/auth/auth.service';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptors';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { NgxSpinnerModule } from 'ngx-spinner';

import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { DialogService } from './services/dialog/dialog.service';
import { TrackerService } from './services/data/tracker.service';
import { MapService } from './services/map/map.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DeviceService } from './services/data/device.service';

registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    trackerModalComponent,
    LoginComponent,
    MenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgxPermissionsModule.forRoot(),
    MaterialFileInputModule,
    HttpClientModule,
    NgxSpinnerModule,
    LeafletModule,
    NgxMaterialTimepickerModule
  ],
  providers: [
    AuthService,
    AuthGuardService,
    DialogService,
    TrackerService,
    DeviceService,
    MapService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'it' },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
